import * as React from "react";
const SvgFiRrLeaderAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leader-alt_svg__a)">
      <path
        fill="#062147"
        d="M24 21a1 1 0 0 1-1 1H11c-.552 0-1 .45-1 1a1 1 0 0 1-2 0c0-1.302.839-2.402 2-2.816V17H4v6a1 1 0 1 1-2 0v-6.35a3.5 3.5 0 0 1-2-3.15v-4C0 7.57 1.57 6 3.5 6h4.217l5.759-3.544a1 1 0 1 1 1.049 1.703l-6 3.692A1 1 0 0 1 8.001 8H3.5C2.673 8 2 8.672 2 9.5v4c0 .827.673 1.5 1.5 1.5H6v-4a1 1 0 1 1 2 0v4h2c1.103 0 2 .897 2 2v3h11A1 1 0 0 1 24 21M4.5 5a2.5 2.5 0 1 0 0-4.999 2.5 2.5 0 0 0 0 5m6.648 5.293a1 1 0 0 0 1.376.328l4-2.46a1 1 0 0 0-1.049-1.704l-4 2.461a1 1 0 0 0-.327 1.375m5.428-5.492 1.923.724.699 1.898a.844.844 0 0 0 1.601 0l.707-1.916 1.918-.706a.844.844 0 0 0 0-1.601l-1.899-.7L20.8.576a.845.845 0 0 0-1.601 0l-.717 1.906-1.905.718a.845.845 0 0 0-.001 1.601"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leader-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeaderAlt;
